import React from 'react';
import AgentReportComponent from '../../../Components/Report/AgentReport';

export default function AgentReport() {
    return (
        <div className='page-body'>
            <AgentReportComponent />
        </div>
    );
}